"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addReferralToUrls = exports.makeUrlsSizes = exports.convertUnsplashUrlToSpecificWidth = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isObject = _interopRequireDefault(require("lodash/isObject"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DEFAULT_SIZES = [4020, 2000, 1080, 400, 150];
/**
 * This converts a common unsplash url to different sizes/quality based on arguments
 * @param {*} url
 * @param {*} w
 * @param {*} q
 */

var convertUnsplashUrlToSpecificWidth = function convertUnsplashUrlToSpecificWidth(url, w) {
  var q = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 90;

  // check if we are searching in an unsplash url so we can predict the markup
  if (typeof url === 'string' && url && w && url.search('unsplash') > -1) {
    var newUrl = new URL(url);
    newUrl.searchParams.set('w', Number(w));
    newUrl.searchParams.set('q', Number(q));
    return newUrl.toString();
  }
};
/**
 * This makes and key/value object based on the different sizes and base url
 * @param {*} sizes
 * @param {*} originalUrl
 */


exports.convertUnsplashUrlToSpecificWidth = convertUnsplashUrlToSpecificWidth;

var makeUrlsSizes = function makeUrlsSizes() {
  var sizes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var originalUrl = arguments.length > 1 ? arguments[1] : undefined;

  /* sizes parameter is not being used. Not sure if it should be what gets
    mapped over, and set the default to DEFAULT_SIZES
  */
  return DEFAULT_SIZES.map(function (size) {
    var url = convertUnsplashUrlToSpecificWidth(originalUrl, size);
    return (0, _defineProperty2["default"])({}, size, url || {});
  }).reduce(function (initial, next) {
    var key = Object.keys(next)[0];
    return _objectSpread(_objectSpread({}, initial), {}, (0, _defineProperty2["default"])({}, key, next[key]));
  }, {});
}; // This will add our Endurance referral to unsplash urls.
// It takes the default unsplash object and goes two levels deep
// with adding the referrals to the url's in the object.


exports.makeUrlsSizes = makeUrlsSizes;

var addReferralToUrls = function addReferralToUrls(image) {
  var newImage = _objectSpread({}, image);

  Object.keys(newImage).forEach(function (key) {
    if (typeof newImage[key] === 'string' && newImage[key].indexOf('images.unsplash.com') > -1) {
      newImage[key] = "".concat(newImage[key], "&utm_source=endurance-innovation&utm_medium=referral");
    }

    if ((0, _isObject["default"])(newImage[key])) {
      Object.keys(newImage[key]).forEach(function (objKey) {
        if (typeof newImage[key][objKey] === 'string' && newImage[key][objKey].indexOf('images.unsplash.com') > -1) {
          newImage[key][objKey] = "".concat(newImage[key][objKey], "&utm_source=endurance-innovation&utm_medium=referral");
        }
      });
    }
  });
  return newImage;
};

exports.addReferralToUrls = addReferralToUrls;